(function() {
  function swapProductLayout() {
    var productWrapper = document.querySelector('.product__content-wrapper') || 
                        document.querySelector('.product-single') ||
                        document.querySelector('.product-grid');
    
    if (productWrapper && window.innerWidth > 990) {
      productWrapper.style.display = 'flex';
      productWrapper.style.flexDirection = 'row-reverse';
      
      var mediaWrapper = productWrapper.querySelector('.product__media-wrapper') ||
                        productWrapper.querySelector('.product__column--media');
      
      var infoWrapper = productWrapper.querySelector('.product__info-wrapper') ||
                       productWrapper.querySelector('.product__column--info');
      
      if (mediaWrapper && infoWrapper) {
        mediaWrapper.style.flex = '0 0 55%';
        mediaWrapper.style.maxWidth = '55%';
        
        infoWrapper.style.flex = '0 0 45%';
        infoWrapper.style.maxWidth = '45%';
        infoWrapper.style.paddingRight = '30px';
      }
    } else if (productWrapper && window.innerWidth <= 990) {
      productWrapper.style.flexDirection = 'column';
      
      var mediaWrapper = productWrapper.querySelector('.product__media-wrapper') ||
                        productWrapper.querySelector('.product__column--media');
      
      var infoWrapper = productWrapper.querySelector('.product__info-wrapper') ||
                       productWrapper.querySelector('.product__column--info');
      
      if (mediaWrapper && infoWrapper) {
        mediaWrapper.style.flex = '1';
        mediaWrapper.style.maxWidth = '100%';
        
        infoWrapper.style.flex = '1';
        infoWrapper.style.maxWidth = '100%';
        infoWrapper.style.paddingRight = '0';
      }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapProductLayout);
  } else {
    swapProductLayout();
  }
  
  window.addEventListener('resize', swapProductLayout);
})();